module.exports = __webpack_public_path__ + "static/media/results_flex.cae60c4c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/results_flex.svg
// module id = 1782
// module chunks = 1